import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
  inject,
  DestroyRef,
  signal,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { APIService } from 'src/app/services/APIService/api.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';
import { ClrDatagrid, ClrForm } from '@clr/angular';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { HilfeBeschreibungModalComponent } from '../../_modals/hilfebeschreibungmodal/hilfebeschreibungmodal.component';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { OktaGroupNamePipe } from 'src/app/pipes/okta-group-name.pipe';
import { MrProUserGroupEntity } from 'src/app/models/api/MrProUserGroupEntity';

export interface FormulareRow {
  ID: number;
  Typ: string;
  FeldName: string;
  AuswahlOption: string;
  Bezeichnung: string;
}

/**
 * ✅ MIGRATION NOTE: This component has been updated to extract group data from JWT tokens
 * instead of making separate API calls to getGroupsForFat endpoint. This improves performance
 * and reduces server load. The component maintains backward compatibility by falling back
 * to the API call if groups are not found in the JWT token.
 *
 * JWT groups structure: {id, name, rights, bezeichnung, status, delStatus, GroupType}
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-fatobjekterstellendialog',
  templateUrl: './fatobjekterstellendialog.component.html',
  styleUrls: ['./fatobjekterstellendialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    HilfeBeschreibungModalComponent,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    TablePrettyPrintPipe,
    HideIDColumnsPipe,
    OktaGroupNamePipe,
  ],
})
export class FatobjekterstellendialogComponent implements OnInit, AfterViewInit {
  private apiservice = inject(APIService);
  private authService = inject(AuthService);
  private toastr = inject(ToastService);
  private mrTranslate = inject(MrTranslatePipe);
  private cdRef = inject(ChangeDetectorRef);

  private destroyRef = inject(DestroyRef);
  private editMode = false;
  private editLoadPending = false;
  private viewInitialized = false;
  private vorlageNamesLoaded = false;
  private lpid: number | null = null;
  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);
  dataRefresh = new EventEmitter();

  protected readonly isHelperModalOpen = signal(false);
  protected readonly openedHelperId = signal<number>(null);

  set data(dataIn: any) {
    this.dataRefresh = dataIn.dataRefresh;
    if (dataIn?.id) {
      this.ostammid = dataIn.id;
      this.editMode = true;
    }
    if (dataIn?.lpid) {
      this.lpid = dataIn.lpid;
    }
    if (this.editMode) {
      this.editLoadPending = true;
      if (this.viewInitialized) {
        this.loadExistingFatObjectForEdit();
      }
    }
  }

  objekteGroup = new UntypedFormGroup({
    objektName: new UntypedFormControl('', [Validators.required]),
    vorlageName: new UntypedFormControl('', [Validators.required]),
  });

  ostammid: number = -1;

  tabellensourcetype: number = 0;
  gruppeEnabled = false;
  gruppeinternegruppeid: string = '';
  gruppegruppeid: string = '';

  selectionFormulareIndex: number = 0;
  structures: any;
  formulare: any;
  formulareOriginal: any;
  tabellen: any;
  tabellenOriginal: any;
  stammdaten = { columns: [] };
  spezifikationsdaten = { columns: [], mapping: {} };
  herstellerdaten = { columns: [] };
  canEdit: boolean = true;
  locked: boolean = true;
  typOptions = ['Normales Feld', 'Überschrift', 'Titel'];
  objektTypOptions = [1, 2, 3];
  auswahlOptions = ['Stammdaten', 'Spezifikationsdaten', 'Herstellerdaten'];
  firstColumnId = 'Typ';
  secondColumnId = 'FeldName';

  formReflectData: {
    table: string | null;
    fieldname: string | null;
    fieldType: string | null;
    fieldLength: string | null;
    subheading: string | null;
    value: string | null;
    title?: string | null;
    mainTitle?: string | null;
  }[] = [];

  vorlageNames: Array<{ ID: number; VorlageName: string }>;
  tabellenNames: Array<{
    ID: number;
    Bezeichnung: string;
    HelpBildBase64: string;
    bemerkung: string;
  }>;
  tabellenNameAll: any;

  selectedVorlageName: string;
  selectedTabelleID: number | null = null;
  selected: any = [];
  tabellenCheckboxStates: {
    [vorlageName: string]: { [tabelleID: number]: boolean };
  } = {};

  @ViewChild(ClrDatagrid) grid: ClrDatagrid;
  @ViewChild(ClrForm) form: ClrForm;

  @Output() modalOpen = new EventEmitter<boolean>();

  _currentPage: number = 1;
  set currentPage(newPage: number) {
    this._currentPage = newPage;
  }
  get currentPage() {
    return this._currentPage;
  }

  set _modalOpen(newVal: boolean) {
    this.modalOpen.emit(newVal);
  }

  loading: boolean = true;
  isFormValid: boolean = false;
  isSaving: boolean = false;
  validationErrors: { [key: string]: string } = {};
  saveAttempted: boolean = false;

  tooltips = {
    save: 'Objekt speichern und schließen',
    saveAndNew: 'Objekt speichern und neues erstellen',
    cancel: 'Ohne Speichern schließen',
    createGroup: 'Neue Gruppe für die Zuordnung erstellen',
    selectTemplate: 'Vorlage für das FAT-Objekt auswählen',
    selectTables: 'Messwerte-Tabellen für das Objekt auswählen',
  };

  activeTab: any = {
    formulare: false,
    tabellen: false,
  };

  showmodalselectVorlage: boolean = false;
  isVorlageAddVisible: boolean = false;
  skizzen: any;
  curSkizzen: any = [];
  bemerkungmessung: string = '';

  isGroupVisible: boolean = false;
  groupModalTitle: string = '';
  internalDropdownTitle: string = 'Interne Gruppe';
  customerDropdownTitle: string = 'Gruppe';
  showInternalDropdown: boolean = false;
  internerkunde: any = [];
  kunde: any = [];
  // Grouped views for dropdown rendering
  adminGroups: any[] = [];
  internalGroups: any[] = [];
  externalGroups: any[] = [];
  kundenname: any[] = [];
  kundenort: any[] = [];

  // ✅ NEW: Validated options from existing groups only
  validatedCompanies: string[] = [];
  validatedLocations: string[] = [];

  addKunde: boolean = false;
  editable: boolean = true;
  hasAdminRights: boolean = false;
  canCreateGroups: boolean = false; // ✅ NEW: Admin and internal users can create groups

  @ViewChild('gruppeForm', { static: false, read: ClrForm })
  private clrForm: ClrForm;

  gruppeedit = new UntypedFormGroup({
    kname: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    kort: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
    // Only admins can change this in the UI; defaults to 'external' for everyone else
    groupType: new UntypedFormControl('external'),
  });

  get isGroupFormValid(): boolean {
    return (
      this.gruppeedit.valid &&
      this.gruppeedit.get('kname')?.value?.length >= 3 &&
      this.gruppeedit.get('kort')?.value?.length >= 3
    );
  }

  @ViewChild('_vorlage_new') _vorlage_new: ElementRef;
  @ViewChild('_zaehlercode') _zaehlercode: ElementRef;
  @ViewChild('_zaehlerbezeichnung') _zaehlerbezeichnung: ElementRef;

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    if (this.editLoadPending) {
      this.loadExistingFatObjectForEdit();
    }
  }

  createGroup() {
    // ✅ SECURITY: Only allow admin and internal users to create groups
    if (!this.canCreateGroups) {
      console.warn('🚫 [FAT] User not authorized to create groups');
      this.toastr.error(this.mrTranslate.transform('Sie haben keine Berechtigung, Gruppen zu erstellen.'));
      return;
    }

    // ✅ RESET: Clean and fresh form state every time dialog opens
    this.resetGroupForm();

    // ✅ IMPROVED: Only use validated companies and locations from existing groups
    this.validatedCompanies = [];
    this.validatedLocations = [];
    this.kundenname = [];
    this.kundenort = [];

    // Extract companies and locations from existing validated groups
    this.kunde.forEach((row: any) => {
      let c = row['Bezeichnung'];
      let arr = c.split('.');

      // Add to validated lists (from existing groups)
      if (arr[0] && !this.validatedCompanies.includes(arr[0])) {
        this.validatedCompanies.push(arr[0]);
      }
      if (arr[1] && !this.validatedLocations.includes(arr[1])) {
        this.validatedLocations.push(arr[1]);
      }
    });

    // Sort validated arrays alphabetically
    this.validatedCompanies.sort();
    this.validatedLocations.sort();

    // Use only validated options for suggestions
    this.kundenname = [...this.validatedCompanies];
    this.kundenort = [...this.validatedLocations];

    console.log('🔧 [FAT] Group creation modal data:', {
      validatedCompanies: this.validatedCompanies,
      validatedLocations: this.validatedLocations,
      totalCompanies: this.kundenname.length,
      totalLocations: this.kundenort.length,
    });

    this.isGroupVisible = true;
  }

  cancelGroupCreation() {
    this.isGroupVisible = false;
    this.resetGroupForm();
  }

  // ✅ NEW: Reset group form to pristine state
  private resetGroupForm() {
    this.gruppeedit.reset();
    this.gruppeedit.patchValue({
      kname: '',
      kort: '',
      groupType: 'external',
    });
    this.gruppeedit.markAsUntouched();
    this.gruppeedit.markAsPristine();

    // Clear any validation errors
    Object.keys(this.gruppeedit.controls).forEach(key => {
      this.gruppeedit.get(key)?.setErrors(null);
    });
  }

  saveIfValid() {
    this.clrForm.markAsTouched();

    if (!this.gruppeedit.valid) {
      this.isGroupVisible = true;
      return;
    }

    if (this.gruppeedit.valid) {
      let newExists = false;
      let newKunde =
        this.gruppeedit.value.kname.toString().replace('.', '_') +
        '.' +
        this.gruppeedit.value.kort.toString().replace('.', '_');
      this.kunde.forEach((row: any) => {
        if (newKunde == row['Bezeichnung']) {
          newExists = true;
        }
      });

      if (newExists) {
        this.toastr.warning(this.mrTranslate.transform('Gruppe existiert bereits'));
        return;
      }

      let toSend: any = {};
      toSend.id = 'INSERT';
      toSend.Bezeichnung = newKunde;
      toSend.Rechte = 1;
      toSend.Typ = 1;
      // Pass desired group classification to backend; only admins can set 'internal'
      const chosenType = this.gruppeedit.value.groupType || 'external';
      toSend.GroupType = chosenType;

      this.apiservice
        .setGroups(toSend)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            // ✅ DEBUG: Log the raw response to see what we're getting
            console.log('🔧 [FAT] Raw API response:', response);

            // ✅ NEW: Handle response with warning support
            let res: MrProUserGroupEntity[] = [];
            let warning: string | null = null;

            if (response && typeof response === 'object') {
              // New format: { groups: [...], warning: "..." }
              if (response.groups && Array.isArray(response.groups)) {
                res = response.groups;
                warning = response.warning;
                console.log('🔧 [FAT] Parsed response - Groups:', res.length, 'Warning:', warning);
              }
              // Legacy format: response is directly the groups array
              else if (Array.isArray(response)) {
                res = response;
                console.log('🔧 [FAT] Legacy array response:', res.length);
              }
            } else if (Array.isArray(response)) {
              // Direct array response (legacy)
              res = response;
              console.log('🔧 [FAT] Direct array response:', res.length);
            }

            // ✅ CHECK: If warning indicates group already exists, don't show success
            const groupExistsWarning = warning && warning.includes('existiert bereits');
            console.log('🔧 [FAT] Warning analysis - Warning:', warning, 'GroupExists:', groupExistsWarning);

            // ✅ SUCCESS: Show success message only if no existing group warning
            if (!groupExistsWarning) {
              console.log('🔧 [FAT] Showing success toaster');
              this.toastr.success(this.mrTranslate.transform('Gruppe erfolgreich gespeichert.'));
            }

            // ✅ WARNING: Show warning if group won't be visible due to Okta assignment or already exists
            if (warning) {
              console.log('🔧 [FAT] Processing warning:', warning);
              // Different styling for different types of warnings
              if (groupExistsWarning) {
                console.log('🔧 [FAT] Showing error toaster for existing group');
                this.toastr.error(warning, this.mrTranslate.transform('Fehler'), {
                  timeOut: 6000,
                  extendedTimeOut: 2000,
                });
                // Don't close the modal if group already exists - let user try again
                return;
              } else {
                // Okta assignment warning - informational
                console.log('🔧 [FAT] Showing warning toaster for Okta assignment');
                this.toastr.warning(warning, this.mrTranslate.transform('Hinweis'), {
                  timeOut: 8000,
                  extendedTimeOut: 2000,
                });
              }
            } else {
              console.log('🔧 [FAT] No warning to display');
            }

            // ✅ SMART SELECTION: Find and pre-select the newly created group before updating
            const newItemToSelect = res.find(k => k.Bezeichnung.startsWith(`${newKunde}.`));
            let preSelectCustomer = this.gruppegruppeid; // Keep current selection as fallback
            let preSelectInternal = this.gruppeinternegruppeid; // Keep current selection as fallback

            if (newItemToSelect) {
              const newIsExternal = newItemToSelect.GroupType === 'external';
              const newIsInternal = newItemToSelect.GroupType === 'internal';
              const hasAdmin = res.some(k => k.GroupType === 'admin');

              if (newIsExternal) {
                preSelectCustomer = String(newItemToSelect.ID);
                console.log('🔧 [FAT] Will pre-select new external group:', newItemToSelect.Bezeichnung);
              }
              if (hasAdmin && newIsInternal) {
                preSelectInternal = String(newItemToSelect.ID);
                console.log('🔧 [FAT] Will pre-select new internal group:', newItemToSelect.Bezeichnung);
              }
            }

            // ✅ PRE-SET: Set selections before calling updateKunde
            this.gruppegruppeid = preSelectCustomer;
            this.gruppeinternegruppeid = preSelectInternal;

            // Now update the dropdown lists (which will preserve our pre-set selections)
            this.updateKunde(res);

            // ✅ NEW: Update suggestions with the newly created company and location
            const newCompany = this.gruppeedit.value.kname.toString();
            const newLocation = this.gruppeedit.value.kort.toString();

            if (!this.validatedCompanies.includes(newCompany)) {
              this.validatedCompanies.push(newCompany);
              this.validatedCompanies.sort();
            }

            if (!this.validatedLocations.includes(newLocation)) {
              this.validatedLocations.push(newLocation);
              this.validatedLocations.sort();
            }

            // Update suggestion arrays for next time
            this.kundenname = [...this.validatedCompanies];
            this.kundenort = [...this.validatedLocations];

            this.isGroupVisible = false;
            this.gruppeedit.patchValue({ kname: '', kort: '' });
            this.gruppeedit.markAsUntouched();
          },
          error: err => {
            console.error('Fehler beim Speichern der Gruppe:', err);
            this.toastr.error(this.mrTranslate.transform('Fehler beim Speichern der Gruppe.'));
          },
        });
    }
  }

  getStructures() {
    this.apiservice
      .getFieldStructures()
      .pipe(first())
      .subscribe((val: any) => {
        this.structures = val.rows;
      });

    // ✅ MIGRATION: Get groups from JWT token instead of API call
    try {
      const token = this.authService.getToken();
      if (token && token.groups) {
        // Groups are already embedded in JWT token with structure: {id, name, rights, bezeichnung, status, delStatus, GroupType}
        const groups = Array.isArray(token.groups) ? token.groups : [];
        console.log('🔧 [DEBUG] FAT Dialog - Groups extracted from JWT token:', groups);
        this.updateKunde(groups);
        this.gruppeEnabled = true;
      } else {
        throw new Error('Groups not found in JWT token');
      }
    } catch (error) {
      console.error('Error extracting groups from JWT token:', error);
      this.toastr.error(this.mrTranslate.transform('Fehler beim Laden der Gruppen'));
    }
  }

  updateKunde(groups: any[]) {
    // ✅ DEDUPLICATE: remove duplicate groups by their display key (prefer Bezeichnung then name then ID)
    const seen = new Set<string>();
    const deduped: any[] = [];
    for (const g of groups || []) {
      const key = (g.Bezeichnung || g.name || g.ID || '').toString().trim();
      if (!key) continue; // skip empty
      if (seen.has(key.toLowerCase())) continue; // already added (case-insensitive)
      seen.add(key.toLowerCase());
      deduped.push(g);
    }
    if (deduped.length !== groups.length) {
      console.log(`🔧 [FAT] Deduplicated groups: original=${groups.length} unique=${deduped.length}`);
    }
    groups = deduped;
    // ✅ PRESERVE: Save current selections before updating
    const currentCustomerSelection = this.gruppegruppeid;
    const currentInternalSelection = this.gruppeinternegruppeid;

    const externalGroups = groups.filter(g => g.GroupType === 'external');
    const internalGroups = groups.filter(g => g.GroupType === 'internal');
    const adminGroups = groups.filter(g => g.GroupType === 'admin');
    const hasAdminRights = groups.some(g => g.GroupType === 'admin');
    const hasInternalRights = groups.some(g => g.GroupType === 'internal');

    this.hasAdminRights = hasAdminRights;
    this.canCreateGroups = hasAdminRights || hasInternalRights; // ✅ NEW: Both admin and internal users can create groups
    this.showInternalDropdown = false; // ✅ HIDDEN: Internal dropdown disabled since backend doesn't use it

    // 🔧 Group buckets for rendering with section headers
    this.adminGroups = adminGroups;
    this.internalGroups = internalGroups;
    this.externalGroups = externalGroups;
    // Keep legacy arrays in sync
    this.internerkunde = internalGroups;
    // Show all groups the user belongs to in a single dropdown, grouped visually in template
    this.kunde = [...adminGroups, ...internalGroups, ...externalGroups];
    console.log('🔧 [FAT] Dropdown groups prepared:', {
      adminGroups: this.adminGroups.length,
      internalGroups: this.internalGroups.length,
      externalGroups: this.externalGroups.length,
    });

    // ✅ PRESERVE: Restore previous selections if they still exist in the updated lists
    let customerSelectionRestored = false;
    let internalSelectionRestored = false;

    if (currentCustomerSelection && this.kunde.some(k => k.ID == currentCustomerSelection)) {
      this.gruppegruppeid = currentCustomerSelection;
      customerSelectionRestored = true;
      console.log('🔧 [FAT] Restored customer group selection:', currentCustomerSelection);
    }

    if (
      currentInternalSelection &&
      this.showInternalDropdown &&
      this.internerkunde.some(k => k.ID == currentInternalSelection)
    ) {
      this.gruppeinternegruppeid = currentInternalSelection;
      internalSelectionRestored = true;
      console.log('🔧 [FAT] Restored internal group selection:', currentInternalSelection);
    }

    // ✅ FALLBACK: Auto-select first group only if no previous selection was restored
    if (!customerSelectionRestored && this.kunde.length > 0) {
      this.gruppegruppeid = this.kunde[0].ID;
      console.log('🔧 [FAT] Auto-selected first customer group:', this.kunde[0].Bezeichnung || this.kunde[0].name);
    }

    if (!internalSelectionRestored && this.showInternalDropdown && this.internerkunde.length > 0) {
      this.gruppeinternegruppeid = this.internerkunde[0].ID;
      console.log(
        '🔧 [FAT] Auto-selected first internal group:',
        this.internerkunde[0].Bezeichnung || this.internerkunde[0].name
      );
    }

    // Set appropriate titles based on user type
    this.groupModalTitle = this.mrTranslate.transform('Neue MR.pro Gruppe erstellen');

    // customerDropdownTitle already initialized with default value 'Gruppe'

    console.log('🔧 [FAT] Final dropdown configuration:', {
      hasAdminRights: this.hasAdminRights,
      canCreateGroups: this.canCreateGroups,
      showInternalDropdown: this.showInternalDropdown,
      internalGroupsCount: this.internerkunde.length,
      customerGroupsCount: this.kunde.length,
      customerDropdownTitle: this.customerDropdownTitle,
    });

    // ✅ FIX: Notify Angular of changes to prevent NG0100 ExpressionChangedAfterItHasBeenCheckedError
    this.cdRef.detectChanges();
  }

  selectVorlageName(selectedVorlageName: string) {
    console.log(`🔧 [DEBUG] FAT Dialog - Selecting template: "${selectedVorlageName}"`);
    this.selectedVorlageName = selectedVorlageName;

    const vorlageID = this.getVorlageIDByName(selectedVorlageName);
    console.log(`🔧 [DEBUG] FAT Dialog - Template ID for "${selectedVorlageName}": ${vorlageID}`);
    console.log(`🔧 [DEBUG] FAT Dialog - Available templates for lookup:`, this.vorlageNames);

    if (vorlageID === null) {
      console.error(`🚫 [DEBUG] FAT Dialog - Could not find template ID for "${selectedVorlageName}"`);
      this.toastr.error(`Template "${selectedVorlageName}" nicht gefunden`);
      return;
    }

    this.tabellenCheckboxStates[selectedVorlageName] = {};
    console.log(`🔧 [DEBUG] FAT Dialog - Initialized checkbox states for template: "${selectedVorlageName}"`);

    this.fetchDataForVorlage(vorlageID);

    this.cdRef.detectChanges();
  }

  private initializeCheckboxStates(savedTabelleIDs: number[]) {
    this.tabellenCheckboxStates[this.selectedVorlageName] = {};
    this.tabellenNames.forEach(tabelle => {
      this.tabellenCheckboxStates[this.selectedVorlageName][tabelle.ID] = savedTabelleIDs.includes(tabelle.ID);
    });
  }

  reloadTabellen() {
    const vorlageID = this.getVorlageIDByName(this.selectedVorlageName);
    this.apiservice.getTabellenNamesFAT(vorlageID).subscribe(namesAndIDs => {
      this.tabellenNames = namesAndIDs.data.rows;
      this.tabellenNameAll = namesAndIDs.data.rows;
      // ✅ Sort measurements alphanumerically by Bezeichnung, then by Code
      if (Array.isArray(this.tabellenNames)) {
        const collator: Intl.Collator = new Intl.Collator(undefined, {
          numeric: true,
          sensitivity: 'base',
        });
        this.tabellenNames.sort(
          (a: any, b: any) =>
            collator.compare(a?.Bezeichnung ?? '', b?.Bezeichnung ?? '') ||
            collator.compare(a?.Code ?? '', b?.Code ?? '')
        );
      }
      this.skizzen = namesAndIDs.skizzen;

      if (this.tabellenNames.length > 0) {
        this.selectedTabelleID = this.tabellenNames[0].ID;
      }

      this.apiservice
        .getTabelleIDForVorlage(vorlageID)
        .pipe(first())
        .subscribe(response => {
          const tabelleID = response;
          this.initializeCheckboxStates(tabelleID);
        });
    });
    this.apiservice
      .getTabellenFAT()
      .pipe(first())
      .subscribe(val => {
        this.tabellen = val;
        this.tabellenOriginal = JSON.parse(JSON.stringify(val.rows));
      });
  }

  getCode(id) {
    let c = this.tabellenNameAll.find(x => x.ID == id);
    return c['Code'];
  }

  selectVorlage() {
    this.selectedVorlageName = this._vorlage_new.nativeElement.value;
    this.selectVorlageName(this.selectedVorlageName);
    this.reloadTabellen();
    this.showmodalselectVorlage = false;
  }

  reloadVorlageNamesAndFormData() {
    console.log('🔧 [DEBUG] FAT Dialog - Loading template names...');
    this.apiservice.getVorlageNames().subscribe(
      namesAndIDs => {
        console.log('🔧 [DEBUG] FAT Dialog - Raw API response:', namesAndIDs);
        console.log(`🔧 [DEBUG] FAT Dialog - Response type: ${typeof namesAndIDs}`);
        console.log(`🔧 [DEBUG] FAT Dialog - Is array: ${Array.isArray(namesAndIDs)}`);
        console.log(`🔧 [DEBUG] FAT Dialog - Number of templates: ${namesAndIDs?.length || 0}`);

        this.vorlageNames = namesAndIDs;
        console.log('🔧 [DEBUG] FAT Dialog - Template names stored in component:', this.vorlageNames);

        this.vorlageNamesLoaded = true;

        if (this.editMode) {
          console.log('🔧 [DEBUG] FAT Dialog - Edit mode active, skipping template selection modal');
          this.showmodalselectVorlage = false;
          if (this.selectedVorlageName) {
            this.tryReloadTabellenForSelectedVorlage();
          }
        } else if (namesAndIDs && namesAndIDs.length > 1) {
          console.log('🔧 [DEBUG] FAT Dialog - Multiple templates found, showing selection modal');
          this.showmodalselectVorlage = true;
        } else if (namesAndIDs && namesAndIDs.length === 1) {
          this.selectedVorlageName = namesAndIDs[0]?.VorlageName || '';
          console.log(`🔧 [DEBUG] FAT Dialog - Single template found, auto-selecting: "${this.selectedVorlageName}"`);
          console.log(`🔧 [DEBUG] FAT Dialog - Template ID: ${namesAndIDs[0]?.ID}`);
          if (!this.editMode) {
            this.selectVorlageName(this.selectedVorlageName);
          }
          this.reloadTabellen();
        } else {
          console.warn('🚫 [DEBUG] FAT Dialog - No templates found in response!');
          console.warn('🚫 [DEBUG] FAT Dialog - This will cause vorlageID to be null');
          this.toastr.warning(
            this.mrTranslate.transform('Keine Vorlagen gefunden. Bitte wenden Sie sich an den Administrator.')
          );
        }
      },
      error => {
        console.error('🚫 [DEBUG] FAT Dialog - Error loading template names:', error);
        console.error('🚫 [DEBUG] FAT Dialog - This will prevent template selection');
        this.toastr.error(this.mrTranslate.transform('Fehler beim Laden der Vorlagen. Bitte versuchen Sie es erneut.'));
      }
    );

    this.apiservice
      .getFormulare()
      .pipe(first())
      .subscribe(val => {
        this.formulare = val;
        this.formulare.rows.forEach(row => {
          if (row.Tabelle === 'Spezifikationsdaten') {
            row.Bezeichnung = this.spezifikationsdaten.mapping[row.Bezeichnung] || row.Bezeichnung;
          }
        });
        this.formulareOriginal = JSON.parse(JSON.stringify(val.rows));
      });
  }

  private tryReloadTabellenForSelectedVorlage() {
    if (this.selectedVorlageName && this.vorlageNamesLoaded) {
      this.reloadTabellen();
    }
  }

  private loadExistingFatObjectForEdit() {
    if (!this.editMode || !this.ostammid || !this.lpid) {
      return;
    }

    this.editLoadPending = false;

    this.apiservice
      .getFatFieldValueByID(this.ostammid, this.lpid)
      .pipe(first())
      .subscribe((result: any) => {
        const spezColumns =
          Array.isArray(result?.spezifikationsdaten?.columns) ? result.spezifikationsdaten.columns : [];
        const spezMapping = result?.spezifikationsdaten?.mapping || {};

        this.spezifikationsdaten.columns = spezColumns.map(col => {
          return {
            display: col,
            value: Object.keys(spezMapping).find(key => spezMapping[key] === col),
          };
        });
        this.spezifikationsdaten.mapping = spezMapping;

        this.structures = result.structures?.rows || this.structures;
        this.formulare = result.vorlage;
        this.formulareOriginal = JSON.parse(JSON.stringify(result.vorlage.rows));

        this.selectedVorlageName = result.vorlagename;
        this.showmodalselectVorlage = false;

        this.formReflectData = this.formulare.rows.map((row: FormulareRow) => {
          const reflectData = {
            table: row['Tabelle'],
            fieldname: row['Bezeichnung'],
            subheading: null,
            fieldType: row['Bezeichnung'],
            fieldLength: null,
            value: null,
          };
          this.updateFormReflectData(row, reflectData);
          return reflectData;
        });

        this.formReflectData.forEach(data => {
          switch (data.table) {
            case 'Stammdaten':
              data.value = result?.ostamm?.[data.fieldname as any] ?? null;
              break;
            case 'Spezifikationsdaten':
              data.value = result?.ospez?.[data.fieldname as any] ?? null;
              break;
            case 'Herstellerdaten':
              data.value = result?.oherst?.[data.fieldname as any] ?? null;
              break;
          }
        });

        this.tryReloadTabellenForSelectedVorlage();
      });
  }

  onCheckboxChange(id: number, isChecked: boolean) {
    if (!this.tabellenCheckboxStates[this.selectedVorlageName]) {
      this.tabellenCheckboxStates[this.selectedVorlageName] = {};
    }
    this.tabellenCheckboxStates[this.selectedVorlageName][id] = isChecked;
  }

  getVorlageIDByName(name: string): number | null {
    console.log(`🔧 [DEBUG] FAT Dialog - Looking up template ID for name: "${name}"`);
    console.log(`🔧 [DEBUG] FAT Dialog - Available templates:`, this.vorlageNames);

    if (!this.vorlageNames || this.vorlageNames.length === 0) {
      console.error('🚫 [DEBUG] FAT Dialog - vorlageNames is empty or undefined');
      return null;
    }

    const vorlage = this.vorlageNames.find(
      (vorlage: { ID: number; VorlageName: string }) => vorlage.VorlageName === name
    );

    if (vorlage) {
      console.log(`🔧 [DEBUG] FAT Dialog - Found template: ID ${vorlage.ID} for name "${name}"`);
    } else {
      console.error(`🚫 [DEBUG] FAT Dialog - Template not found for name: "${name}"`);
      console.error(
        `🚫 [DEBUG] FAT Dialog - Available template names:`,
        this.vorlageNames.map(v => v.VorlageName)
      );
    }

    return vorlage ? vorlage.ID : null;
  }

  panelChange(event, tabelle) {
    if (event) {
      let curname = this.tabellenNames.find(x => x.ID == tabelle.ID);
      this.tabellensourcetype = curname['SourceType'];

      this.tabellen.rows = this.tabellenOriginal.filter(x => x.SZAEHNID == tabelle.ID);
      console.log('panel is opening');
    }
  }

  fetchDataForVorlage(vorlageID: number) {
    console.log(`🔧 [DEBUG] FAT Dialog - Fetching form data for vorlageID: ${vorlageID}`);

    if (!vorlageID || vorlageID === null) {
      console.error('🚫 [DEBUG] FAT Dialog - Cannot fetch data: vorlageID is null or undefined');
      return;
    }

    // Ensure structures are loaded first (fixes race condition where fieldType wasn't set)
    const ensureStructures =
      this.structures ?
        Promise.resolve()
      : this.apiservice
          .getFieldStructures()
          .pipe(first())
          .toPromise()
          .then((val: any) => {
            this.structures = val.rows;
            console.log(`🔧 [DEBUG] FAT Dialog - Structures loaded: ${this.structures?.length || 0} entries`);
          });

    // Now fetch form data after structures are ready
    ensureStructures.then(() => {
      this.apiservice.getFormDataForVorlage(vorlageID).subscribe(
        data => {
          console.log(`🔧 [DEBUG] FAT Dialog - Form data received for vorlageID ${vorlageID}:`, data);
          console.log(`🔧 [DEBUG] FAT Dialog - Data is array: ${Array.isArray(data)}`);
          console.log(
            `🔧 [DEBUG] FAT Dialog - Structures available: ${!!this.structures}, count: ${this.structures?.length || 0}`
          );

          if (Array.isArray(data)) {
            console.log(`🔧 [DEBUG] FAT Dialog - Processing ${data.length} form rows`);
            this.formulare.rows = data;
            this.formReflectData = data.map((row: FormulareRow) => {
              const reflectData = {
                table: row['Tabelle'],
                fieldname: row['Bezeichnung'],
                subheading: null,
                fieldType: row['Bezeichnung'],
                fieldLength: null,
                value: null,
              };
              this.updateFormReflectData(row, reflectData);
              console.log(
                `🔧 [DEBUG] FAT Dialog - Row processed: fieldname=${reflectData.fieldname}, fieldType=${reflectData.fieldType}, subheading=${reflectData.subheading}`
              );
              return reflectData;
            });

            console.log(`🔧 [DEBUG] FAT Dialog - Created ${this.formReflectData.length} form reflect data entries`);

            this.formReflectData.map(elem => {
              this.objekteGroup.addControl(elem.fieldname, new UntypedFormControl(elem, Validators.maxLength(3)));
            });

            console.log(`🔧 [DEBUG] FAT Dialog - Added form controls to objekteGroup`);
          } else {
            console.warn('🚫 [DEBUG] FAT Dialog - Form data is not an array:', data);
          }
        },
        error => {
          console.error(`🚫 [DEBUG] FAT Dialog - Error fetching form data for vorlageID ${vorlageID}:`, error);
        }
      );
    });
  }

  public close() {
    this.closedialog.next(true);
  }

  tabChange() {
    this.selected = [];
    this.currentPage = 1;
  }

  sendForFormulare() {
    if (!this.gruppegruppeid) {
      this.toastr.warning(this.mrTranslate.transform('Bitte fülle die Gruppenauswahl korrekt aus.'));
      return;
    }

    let missingBez: boolean = false;
    let nameBez: string = '';
    this.formReflectData.forEach((row: any) => {
      if (row['table'] == 'Stammdaten' && row['fieldname'] == 'Bezeichnung' && row['value'] == null) {
        nameBez = row['subheading'];
        missingBez = true;
      }
    });

    if (missingBez) {
      this.toastr.warning(nameBez + ' → ' + this.mrTranslate.transform('Eintrag fehlt'));
      return;
    }

    let vorlageID = this.getVorlageIDByName(this.selectedVorlageName);
    let gruppeid = parseInt(this.gruppegruppeid);

    // Debug logging for vorlageID issue
    console.log('🔧 [DEBUG] FAT Dialog Save - Template Selection Debug:');
    console.log(`🔧 [DEBUG] - selectedVorlageName: "${this.selectedVorlageName}"`);
    console.log(`🔧 [DEBUG] - vorlageNames array:`, this.vorlageNames);
    console.log(`🔧 [DEBUG] - calculated vorlageID: ${vorlageID}`);
    console.log(`🔧 [DEBUG] - gruppeid: ${gruppeid}`);
    console.log(`🔧 [DEBUG] - form values:`, this.objekteGroup.value);

    const tabelleIDUpdates = this.tabellenCheckboxStates[this.selectedVorlageName];
    console.log(`🔧 [DEBUG] - tabelleIDUpdates:`, tabelleIDUpdates);

    if (vorlageID === null || vorlageID === undefined) {
      console.error('🚫 [DEBUG] vorlageID is null/undefined - cannot proceed with API call');
      this.toastr.error(
        this.mrTranslate.transform('Vorlage nicht gefunden. Bitte wählen Sie eine gültige Vorlage aus.')
      );
      return;
    }

    if (vorlageID !== undefined && tabelleIDUpdates !== undefined) {
      this.apiservice
        .addAnlageByFAT(this.formReflectData, vorlageID, gruppeid, this.ostammid, tabelleIDUpdates)
        .pipe(first())
        .subscribe(val => {
          if (val) {
            this.ostammid = parseInt(val.toString());
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
            this.dataRefresh.emit();
            this.editable = false;
            this.gruppeEnabled = false;
          }
        });
    } else {
      console.error('Missing vorlageID or no checkboxes selected');
    }
  }

  private updateFormReflectData(row: any, reflectData: any) {
    if (row[this.firstColumnId] === 'Überschrift') {
      reflectData.mainTitle = null;
      reflectData.title = row['FeldName'];
      reflectData.subheading = null;
    } else if (row[this.firstColumnId] === 'Normales Feld') {
      reflectData.mainTitle = null;
      reflectData.title = null;
      reflectData.subheading = row['FeldName'];
    } else if (row[this.firstColumnId] === 'Titel') {
      reflectData.mainTitle = row['FeldName'];
      reflectData.title = null;
      reflectData.subheading = null;
    }
    let columnName = row['Bezeichnung'];

    if (columnName != null && this.structures) {
      let stable = 'ostamm';

      if (row['Tabelle'] === 'Spezifikationsdaten') stable = 'ospez';

      if (row['Tabelle'] === 'Herstellerdaten') stable = 'oherst';

      const rowToDelete = this.structures.find(
        (row: any) => row.TABLE_NAME === stable && row.COLUMN_NAME === columnName
      );

      if (rowToDelete != undefined) {
        let formFieldType;
        switch (rowToDelete.DATA_TYPE.toUpperCase()) {
          case 'VARCHAR':
          case 'TEXT':
            formFieldType = 'text';
            break;
          case 'DATETIME':
            formFieldType = 'date';
            break;
          case 'DECIMAL':
          case 'INT':
          case 'FLOAT':
            formFieldType = 'dropdown';
            break;
          case 'BIT':
            formFieldType = 'checkbox';
            break;
        }
        reflectData.fieldType = formFieldType;
      }
    }
  }

  triggerLock() {
    this.locked = !this.locked;
  }

  handleAuswahlOptionChange(row: any, value: string) {
    row['Tabelle'] = value;
  }

  handleModalReload() {
    this.reloadVorlageNamesAndFormData();
    this.reloadTabellen();
  }

  ngOnInit() {
    this.getStructures();
    this.reloadVorlageNamesAndFormData();

    this.apiservice
      .getStammdatenColumns()
      .pipe(first())
      .subscribe(columns => {
        this.stammdaten.columns = columns;
      });
    this.apiservice
      .getSpezifikationsdaten()
      .pipe(first())
      .subscribe(data => {
        const spezColumns = Array.isArray(data?.columns) ? data.columns : [];
        const spezMapping = data?.mapping || {};

        this.spezifikationsdaten.columns = spezColumns.map(col => {
          return {
            display: col,
            value: Object.keys(spezMapping).find(key => spezMapping[key] === col),
          };
        });
        this.spezifikationsdaten.mapping = spezMapping;
      });
    this.apiservice
      .getHerstellerdatenColumns()
      .pipe(first())
      .subscribe(columns => {
        this.herstellerdaten.columns = columns;
      });
  }
}
